import { useEffect, useState } from "react";
import {
  StatisticPanels,
  StatisticPanelsProps,
} from "../../../Components/StaticticsPanels/StatisticsPanel";
import CompositionAssetAuditTable from "../MusicAssetAuditComponents/CompositionAssetAudits";
import { apiService } from "../../../api/api";

const SyncOwnershipRoute = () => {
  const [statsCards, setStatsCards] = useState<StatisticPanelsProps>({
    cards: [
      {
        header: "Total Sound Recording Assets",
        tooltip: "The number of Sound Recordings in Youtube",
        value: "",
        id: "totalSoundRecordingAssets",
      },
      {
        header: "Sound Recording Assets with Sync Issues",
        tooltip:
          "The percentage of music videos in the database, with a sound recording attached",
        value: "",
        id: "soundRecordingAssetsWithSyncIssues",
      },
      {
        header: "Correct Sync on Sound Recording",
        tooltip: "The number of sound recordings in the database",
        value: "",
        id: "correctSyncOnSoundRecording",
      },
      {
        header: "Impacted Daily Views",
        tooltip:
          "The percentage of sound recordings in the database, with a music video attached",
        value: "",
        id: "impactedDailyViews",
      },
      {
        header: "Updated At",
        tooltip: "Timestamp of the data",
        value: "",
        id: "Timestamp",
      },
    ],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const incorrectComposition =
          await apiService.musicAssetAudit.getIncorrectOwnershipSync();

        if (Array.isArray(incorrectComposition.data.metrics)) {
          const mostRecentIncorrectComposition =
            incorrectComposition.data.metrics.reduce(
              (
                prev: { timestamp: { _seconds: number } },
                current: { timestamp: { _seconds: number } }
              ) => {
                if (current.timestamp._seconds > prev.timestamp._seconds) {
                  return current;
                } else {
                  return prev;
                }
              }
            );

          const timestamp = new Date(
            mostRecentIncorrectComposition.timestamp._seconds * 1000
          );
          const day = String(timestamp.getDate()).padStart(2, "0");
          const month = String(timestamp.getMonth() + 1).padStart(2, "0");
          const year = timestamp.getFullYear();
          const date = `${day}/${month}/${year}`;

          setStatsCards({
            cards: [
              {
                header: "Total Sound Recording Assets",
                tooltip: "The number of Sound Recordings in Youtube",
                value: parseFloat(
                  mostRecentIncorrectComposition.assetCount
                ).toLocaleString(),
                id: "totalSoundRecordingAssets",
              },
              {
                header: "Sound Recording Assets with Sync Issues",
                tooltip:
                  "The percentage of music videos in the database, without a sound recording attached",
                value: mostRecentIncorrectComposition.issueCount,
                id: "soundRecordingAssetsWithSyncIssues",
              },
              {
                header: "Correct Sync on Sound Recording",
                tooltip: "Number of sound recordings in the database",
                value:
                  parseFloat(
                    mostRecentIncorrectComposition.healthyPercent
                  ).toFixed(2) + " %",
                id: "correctSyncOnSoundRecording",
              },
              {
                header: "Impacted Daily Views",
                tooltip:
                  "Percentage of sound recordings with a music video attached",
                value: parseFloat(
                  mostRecentIncorrectComposition.dailyViewsImpact
                ).toLocaleString(),
                id: "impactedDailyViews",
              },
              {
                header: "Updated At",
                tooltip: "Timestamp of the data",
                value: date,
                id: "Timestamp",
              },
            ],
          });
        }
      } catch (error) {
        console.error("Error fetching sync ownership data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <StatisticPanels cards={statsCards.cards} />
      <CompositionAssetAuditTable />
    </>
  );
};

export default SyncOwnershipRoute;
